import {DecisionBtnPair} from "src/app/model/DecisionBtnPair";
import { ReviewResult } from "../constant/Enums";

export const CASE_DECISION_BUTTON_PAIR_CONFIG: { [key: string]: DecisionBtnPair } = {
    AMCEagle: {
        actionBtnTxt: 'Inactivate',
        noActionBtnTxt: 'NO Action',
        noActionReopenBtnTxt: 'Reopen to Inactivate',
        actionResult: ReviewResult.INACTIVATED
    }
}

export const DEFAULT_DECISION_BUTTON_PAIR = {
    actionBtnTxt: 'Offboard DP',
    noActionBtnTxt: 'NO Action',
    noActionReopenBtnTxt: 'Reopen to Offboard',
    actionResult: ReviewResult.OFFBOARDED
}